import { render, staticRenderFns } from "./CtrlTemperatura.vue?vue&type=template&id=ee521ad0&"
import script from "./CtrlTemperatura.vue?vue&type=script&lang=js&"
export * from "./CtrlTemperatura.vue?vue&type=script&lang=js&"
import style0 from "./CtrlTemperatura.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
